export const toPascal = (o) => {
  let newO, origKey, newKey, value;
  if (o === null || o === undefined) {
    return o;
  }
  if (o instanceof Array) {
    return o.map((value) => {
      if (typeof value === 'object') {
        value = toPascal(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};
